module.exports = __webpack_public_path__ + "img/bg-rep.8477e8cc.jpg";